export var AccountTypeEnum;
(function (AccountTypeEnum) {
    AccountTypeEnum[AccountTypeEnum["Email"] = 0] = "Email";
    AccountTypeEnum[AccountTypeEnum["Phone"] = 1] = "Phone";
    AccountTypeEnum[AccountTypeEnum["Google"] = 2] = "Google";
    AccountTypeEnum[AccountTypeEnum["Apple"] = 3] = "Apple";
    AccountTypeEnum[AccountTypeEnum["Telegram"] = 4] = "Telegram";
    AccountTypeEnum[AccountTypeEnum["Facebook"] = 5] = "Facebook";
    AccountTypeEnum[AccountTypeEnum["Twitter"] = 6] = "Twitter";
})(AccountTypeEnum || (AccountTypeEnum = {}));
export const AccountTypeKeyEnum = {
    Email: 'Email',
    Phone: 'Phone',
    Google: 'Google',
    Apple: 'Apple',
    Telegram: 'Telegram',
    Facebook: 'Facebook',
    Twitter: 'Twitter',
};
export class BaseService {
    constructor(request) {
        this._request = request;
    }
}
export * from './services.js';
export * from './communityRecovery.js';
export * from './search.js';
export * from './verification.js';
export * from './connect.js';
export * from './ramp.js';
export * from './assets.js';
export * from './token.js';
export * from './transaction.js';
export * from './receive.js';
export * from './send.js';
export * from './activity.js';
export * from './allowance.js';
export * from './security.js';
export * from './common.js';
